<template>
  <v-dialog
    v-model="start_stop_dialog"
    scrollable
    max-width="600px"
    persistent
    v-if="trip"
  >
    <v-form>
      <v-card>
        <v-toolbar color="white" fixed>
          <h3>
            {{
              trip.status == 3
                ? $i18n.t("Trip Start Details")
                : trip.status == 4
                ? $i18n.t("Trip Stop Details")
                : $i18n.t("Update Trip Details")
            }}
          </h3>
        </v-toolbar>
        <v-card-text>
          <v-container dense>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="
                  trip.status == 3 ||
                  trip.status == 4 ||
                  trip.status == 5 ||
                  trip.status == 6 ||
                  trip.status == 20 ||
                  trip.status == 21
                "
              >
                <v-text-field
                  v-model="trip.startKm"
                  :label="$i18n.t('Start KM')"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="
                  trip.status == 4 ||
                  trip.status == 5 ||
                  trip.status == 6 ||
                  trip.status == 20 ||
                  trip.status == 21
                "
              >
                <v-text-field
                  v-model="trip.endKm"
                  :label="$i18n.t('Stop KM')"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="
                  trip.status == 3 ||
                  trip.status == 4 ||
                  trip.status == 5 ||
                  trip.status == 6 ||
                  trip.status == 20 ||
                  trip.status == 21
                "
              >
                <v-text-field
                  v-model="trip.dutySlipNo"
                  :label="$i18n.t('Ref No')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="trip.status > 3">
                <z-date-picker
                  :label="$i18n.t('Reporting Date')"
                  v-model="trip.reportingDate"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="trip.status > 3">
                <z-date-picker
                  :label="$i18n.t('Delivery Date')"
                  v-model="trip.deliveryDate"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="
                  trip.status == 4 ||
                  trip.status == 5 ||
                  trip.status == 6 ||
                  trip.status == 20 ||
                  trip.status == 21
                "
              >
                <z-date-picker
                  v-if="trip.pod"
                  :label="$i18n.t('POD Received Date')"
                  v-model="trip.pod.receivedDate"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="trip.status == 20 || trip.status == 21"
              >
                <z-date-picker
                  v-if="trip.pod"
                  :label="$i18n.t('POD Submit Date')"
                  v-model="trip.pod.submitDate"
                />
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="
                  trip.status == 4 ||
                  trip.status == 5 ||
                  trip.status == 6 ||
                  trip.status == 20 ||
                  trip.status == 21
                "
              >
                <v-file-input
                  chips
                  :label="$i18n.t('POD Document')"
                  @change="handlePODFileUpload()"
                  v-model="pod_file_upload"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row v-if="trip.pod && trip.pod.attachments">
              <v-col
                cols="12"
                sm="4"
                md="6"
                lg="6"
                v-for="(picture, index) in trip.pod.attachments"
                :key="index"
              >
                <v-card>
                  <z-confirm-button
                    fab
                    color="red"
                    x-small
                    class="image-remove"
                    :message="$i18n.t('Remove Image ?')"
                    @click="removePODAttachment(picture.time)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </z-confirm-button>
                  <a :href="picture.url">
                    <v-img
                      v-if="isPDF(picture.url)"
                      src="@/assets/pdf_format.png"
                      aspect-ratio="2"
                      class="grey darken-4"
                    ></v-img>
                    <v-img
                      v-else
                      :src="picture.url"
                      aspect-ratio="2"
                      class="grey darken-4"
                    ></v-img>
                  </a>
                  <v-row class="px-2">
                    <v-col cols="12" md="12" lg="12">
                      {{ picture.time | moment("HH:mm DD MMM YYYY") }}
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small>{{ $i18n.t("* indicates required field") }}</small>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeSSDialog(false)"
            >Close</v-btn
          >
          <v-btn
            color="success darken-1"
            @click="updateStartStop()"
            :loading="ss_loading"
            >{{
              trip.status == 3
                ? $i18n.t("Start Trip")
                : trip.status == 4
                ? $i18n.t("Stop Trip")
                : $i18n.t("Update")
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doPostForm, doGet } from "@/store/common/module/apis";

@Component({
  name: "TripStartStop",
  props: {
    trip: {
      default: null,
    },
    label: {
      default: "Duty Close",
    },
    showSSDialog: {
      default: false,
    },
  },
})
export default class TripStartStop extends Vue {
  start_stop_dialog = false;
  ss_loading = false;
  pod_file_upload = null;
  startStop = {
    startKm: null,
    endKm: null,
    deliveryDate: null,
    reportingDate: null,
    pod: { receivedDate: null, submitDate: null },
  };

  isPDF(_url) {
    if (_url && _url.includes(".pdf")) {
      return true;
    }
    return false;
  }

  handlePODFileUpload(files) {
    if (files) {
      this.pod_file_upload = files[0];
    }
  }

  get loading() {
    return common.loading;
  }

  mounted() {
    if (this.trip) {
      if (!this.trip.deliveryDate) this.trip.deliveryDate = null;
      if (!this.trip.reportingDate) this.trip.reportingDate = null;
      if (!this.trip.pod) this.trip.pod = {};
      if (!this.trip.pod.receivedDate) this.trip.pod.receivedDate = null;
      if (!this.trip.pod.submitDate) this.trip.pod.submitDate = null;
    }
  }

  //   async save() {
  //     common.setLoading(true);
  //     try {
  //       await doPost(`/api/trip/${this.trip._id}/deploy`, this.trip);
  //       common.setLoading(false);
  //       common.showMessage("Duty closed");
  //       this.closeDialog(true);
  //     } catch (e) {
  //       common.setLoading(false);
  //       common.setError(e.showMessage);
  //     }
  //   }

  async removePODAttachment(_time) {
    try {
      common.setLoading(true);
      await doGet(
        "/api/trip/" + this.trip._id + "/pod/attachment/" + _time + "/delete"
      );
      this.closeSSDialog(true);
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async updateStartStop() {
    try {
      common.setLoading(true);
      this.trip.dutySlipNo = this.trip.dutySlipNo ? this.trip.dutySlipNo : "";
      const formData = new FormData();
      formData.set("startKm", this.trip.startKm);
      formData.set("endKm", this.trip.endKm);
      formData.set("dutySlipNo", this.trip.dutySlipNo);
      formData.set("deliveryDate", this.trip.deliveryDate);
      formData.set("reportingDate", this.trip.reportingDate);
      formData.set(
        "podReceivedDate",
        this.trip.pod ? this.trip.pod.receivedDate : null
      );
      formData.set(
        "podSubmitDate",
        this.trip.pod ? this.trip.pod.submitDate : null
      );
      if (this.pod_file_upload) {
        formData.append("file", this.pod_file_upload);
      }
      this.ss_loading = true;
      await doPostForm(`/api/trip/${this.trip._id}/start/stop`, formData);
      this.ss_loading = null;
      this.pod_file_upload = null;
      this.closeSSDialog(true);
    } catch (e) {
      this.ss_loading = null;
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  @Watch("showSSDialog")
  onShowDialogChange(val) {
    this.start_stop_dialog = val;
  }

  closeSSDialog(reload) {
    this.start_stop_dialog = false;
    this.$emit("startStopDialogClose", reload);
  }
}
</script>
